import { MenuNode }  from './MenuNode';
import { ZoneData } from './ZoneData';
import { BaseSensor }  from './BaseSensor';
import { TimeFrame  } from './TimeFrame';
import { ValueChangedConfirmation  } from './ValueChangedConfirmation';

export class Helper{


	_debug:boolean=false;
	debug(msg:string):void{ 
		if(this._debug){
			console.debug("Helpers: "+msg);
		} 
	}

	runHook(hook:string, args:any,context:MenuNode){

		let parts=Helper.split(hook,'.');
		let obj = MenuNode.ioService;
		this.debug("RUNNING HOOK: "+hook);
		let methodName="";
		if(parts.length == 1){
			methodName = parts[0];
			if(obj[methodName]){
				return obj[methodName]();
			}
			methodName = 'get'+Helper.ucwords(parts[0]);
			if(obj[methodName]){
				return obj[methodName]();
			}
			return null;
		}
		for(let i=1;i<parts.length;i++){
			methodName = 'get'+Helper.ucwords(parts[i]);
			if(!obj[methodName]){
				this.debug("Method not found: "+methodName+ " trying "+parts[i]);
				methodName=parts[i];
				if(!obj[methodName]){
					this.debug("Method not found: "+obj.constructor.name+ "::"+parts[i]);
					return;
				}else{
					this.debug("Found method "+parts[i] + " on "+obj.constructor.name);
				}
			}
			if(i != (parts.length-1)){
				obj = obj[methodName]();
			}
		}

		return obj[methodName](args);
	}


	onConfirm(args:any,context :MenuNode){
		this.debug("OnConfirm-Action on " + context.getName());
		this.debug("Action: ")
		this.debug(context.onConfirmAction);

		if (context.onConfirmAction) {
			if(context.onConfirmAction.startsWith('run:')){
				return this.runHook(context.onConfirmAction.replace('run:',''),args,context);
			}
			let result = context.onConfirmAction.replace('set:', '').replace('{{', '').replace('}}', '');
			let parts = Helper.split(result,'.');
			switch (parts[0]) {
				case 'currentTimeFrame':{
					if(parts[1]=="temperature"){
						MenuNode.ioService.currentTimeFrame.setValue(args);
					}
					break;
				}
				case 'ioService':{
					this.debug("Getting from ioService.");
					switch(parts[1]){
						case 'zoneCount':{
							this.debug("Getting from ioService.zoneCount");
							context.debug("Returning zone-count: "+MenuNode.ioService.deviceInfo().getZoneCount().toString());
							this.debug("Returning "+MenuNode.ioService.deviceInfo().getZoneCount().toString());
							return MenuNode.ioService.deviceInfo().getZoneCount().toString();
						}
						case 'contactPhone':{
							//console.log("Setting contact numer to"+args);
							MenuNode.ioService.setContactPhone(args);
							return;
						}
						case 'contactName':{
							//console.log("Setting contact name to"+args);
							MenuNode.ioService.setContactName(args);
							return;
						}
						default:{
								
							let obj=MenuNode.ioService;
							let hasObj = false;
							for(let i=1;i<parts.length-2;i++){
								let methodName = 'get'+Helper.ucwords(parts[i]);
								this.debug("checking for method "+ methodName + " on "+ obj.constructor.name);
									if(obj[methodName]){
										hasObj = true;
										obj = obj[methodName]();
								}else{
									this.debug("Method not found: "+methodName);
								}

							}

							let methodName = 'set'+Helper.ucwords(parts[parts.length-2]);
							let arg = parts[parts.length -1];
							if(obj[methodName]){
								this.debug("Calling "+obj.constructor.name + '.'+methodName+'('+arg+')');
								obj[methodName](arg);
							}else{
								this.debug("No setter "+methodName+'('+arg+')' + " on "+obj.constructor.name);
							}

							return;
							/*
							let obj = MenuNode.ioService;
							let methodName = 'set'+Helper.ucwords(parts[1]);
							if(obj[methodName]){
								return obj[methodName](args);
							}else{
								this.debug(" THERE IS NO METHOD "+methodName);
							}
							return;
							*/
						}
					}
				}
				case 'sensor': {
					let sensor: BaseSensor;
					switch (parts[1]) {
						case 'temperature': {
							sensor = MenuNode.ioService.sensors.getTemperatureSensor(parts[2]);
							break;
						}
						case 'humidity': {
							sensor = MenuNode.ioService.sensors.getHumiditySensor(parts[2]);
							break;
						}
						case 'airquality':{
							sensor = MenuNode.ioService.sensors.getAirQualitySensor(parts[2]);
							break;
						}
						case 'ventilation':{
							sensor = MenuNode.ioService.sensors.getVentilationSensor(parts[2]);
							break;
						}
						case 'pressure': {
							sensor = MenuNode.ioService.sensors.getPressureSensor(parts[2]);
							break;
						}
						default: {

						}
					}
					if(sensor){
							let current = sensor.getCurrentValue();
							sensor.setCurrentValue(args);
							return new ValueChangedConfirmation(sensor.getName(),current.toString(),args,context);
							
					}
					break;
				}
				case 'deviceinfo':{

					let val = parts[2];
					if(val == undefined){
						val = args;
					}
					let devInfo = MenuNode.ioService.deviceInfo()
					if(devInfo.hasScale(parts[1])){
						let oldVal = (devInfo.getScale(parts[1]).getCurrentValue()).toString();
						devInfo.setScaleValue(parts[1],parseFloat(val));
						//console.log("Setting device-info scale "+parts[1]);
						return new ValueChangedConfirmation(parts[1],oldVal,val,context);
					}
					if(devInfo.hasValue(parts[1])){
						let oldVal = devInfo.getRawValue(parts[1]);
						devInfo.setValue(parts[1],val);
						return new ValueChangedConfirmation(parts[1],oldVal,val,context);
						
					}

					MenuNode.ioService.deviceInfo().setValue('mode',parts[1]);
					return;
				
				}
				case 'zeitprogrammassistent':{

					let data = MenuNode.ioService.getZeitprogrammAssistent();
					let val = parts[2];
					if(val == undefined){
						val = args;
					}
					if(data.hasScale(parts[1])){
						data.setScaleValue(parts[1],args);
						return
					}
					if(data.hasValue(parts[1])){
						data.setValue(parts[1],val);
						return
					}
					this.debug("Cannot return value for: "+parts.join('.'));

				}
				case 'heatingCircuit':{
					let idx = parts['1'];
					let ids :Array<number>;
					if(idx == 'all'){
						ids = MenuNode.ioService.deviceInfo().getHeatingCircuitIds();
					}else{
						ids = [ parseInt(idx) ];
					}
					let val=null;
					if(parts[3] != undefined && parts[3] != null){
						val = parts[3];
					}else{
						val = args;
					}
					for(let id of ids){
						let hc = MenuNode.ioService.deviceInfo().getHeatingCircuitById(id);
						if(hc.hasScale(parts[2])){
							let oldVal = hc.getScale(parts[2]).getCurrentValue();
							hc.getScale(parts[2]).setCurrentValue(val);
							return new ValueChangedConfirmation(parts[2],oldVal.toString(),val,context);
							
						}
						if(hc.hasValue(parts[2])){
							this.debug("Setting heatingCircuitValue " + parts[2] + " to "+val);

							let oldVal = hc.getRawValue(parts[2]);
							hc.setValue(parts[2],val);
							return new ValueChangedConfirmation(parts[2],oldVal,val,context);
							
						}
						this.debug("Cannot set heatingCircuit "+parts[2] +  " to "+val);
						return;
					}

					return;
				}
				case 'zone':{
					let id=(parts['1']);
					let property = parts['2'];
					let value = parts['3'];
					//console.log("onConfirm / zone."+id+"property");
					if(value == undefined || value == null){
						value = args;
					}
					let defaultId = MenuNode.ioService.deviceInfo().getDefaultZoneId();
					if(id == "default"){
						id=defaultId+"";
					}
					let ids = [];
					let returnValue:null;
					if(id == "all"){
						ids = MenuNode.ioService.deviceInfo().getZoneIds();
					}else{
						ids.push(id);
					}
					let retVal :any=undefined;
					let confirmation : ValueChangedConfirmation;
					for(let idx of ids){
						
						let zone : ZoneData = MenuNode.ioService.deviceInfo().getZoneById(idx);
						if(zone == undefined){
							this.debug("Cannot find zone "+idx);
							return;
						}
						if(zone.hasScale(property)){
							let scale = zone.getScale(property);
							let oldVal = zone.getScale(property).getCurrentValue();
							scale.setCurrentValue(parseFloat(value));
							
							confirmation = new ValueChangedConfirmation(property,oldVal.toString(),value,context);
							
							if(ids.length == 1){
								//console.log("Returning this scale as return-value");
								retVal = scale;
							}else{
								if(idx == defaultId){
									retVal = scale;
								}
							}
							continue;
						}else{
							//console.log("Scale not found: "+property);
						}
						if(zone.hasValue(property)){
							let oldVal = zone.getRawValue(property);
							zone.setValue(property,value);
							
							confirmation = new ValueChangedConfirmation(property,oldVal,value,context);
							continue;
						}
						if(zone.hasDate(property)){
							let oldVal = zone.getDate(property).getTime();
							let v = new Date(value);
							zone.setDate(property,v);
							confirmation = new ValueChangedConfirmation(property,oldVal.toString(),v.toString(),context);	
							
							
							continue;
						}
						let sensor=zone.getSensor(parts[3],parts[4]);
						if(sensor != null && sensor != undefined){
							let oldVal = sensor.getCurrentValue();
							sensor.setCurrentValue(args);
							confirmation = new ValueChangedConfirmation(parts.join('.'),oldVal.toString(),args,context);
							continue;
						}
						this.debug("Cannot make sense of "+parts.join('.'));

					}
					//console.log("Returning confirmation: "+confirmation.toString());
					return confirmation;
					//return retVal;

				}
				case 'menu': {
					let targetNode = context.findFromRoot(parts[1]);
					switch (parts[2]) {
						case 'value': {
							this.debug("Setting value on "+parts[2] + " to "+args);
							targetNode.setValue(args);
							return;
						}
						case 'name': {
							targetNode.setName(args);
							return;
						}
						default: {
							this.debug("No defined action for " + parts[2]);
							return;
						}
					}
				}
				case 'clear':{
					let address=parts[1].replace('timeframes[','').replace(']','');
				
					let sourceArgs=Helper.split(address,',');
					let sourceTable =(sourceArgs[0].trim()); 
					let sourceZone = (sourceArgs[1].trim());
					let sourceDay = parseInt(sourceArgs[2].trim());
					if(sourceZone == 'default'){
							sourceZone = ""+MenuNode.ioService.deviceInfo().getDefaultZoneId();
					}
						
					MenuNode.ioService.deviceInfo().getZoneById(parseInt(sourceZone)).getTimeFrameManager(sourceTable).clearDay(sourceDay);
					return new ValueChangedConfirmation('','0','1',context);
				}
				case 'copy':{
					if(parts.length != 3){
						this.debug("Error: copy needs to arguments");
					}
					let source=parts[1];
					let target=parts[2];
					if(source.startsWith('timeframe')){
						if(!target.startsWith('timeframe')){
							this.debug("timeframe has to be copies to a timeframe");
							return;
						}
						source=source.replace('timeframes[','').replace(']','');
						target=target.replace('timeframes[','').replace(']','');
						
						let sourceArgs=Helper.split(source,',');
						let sourceTable =(sourceArgs[0].trim()); 
						let sourceZone = (sourceArgs[1].trim());
						let sourceDay = parseInt(sourceArgs[2].trim());

						let targetArgs=Helper.split(target,',');
						let targetTable = (targetArgs[0].trim());						
						let targetZone = (targetArgs[1].trim());
						let targetDay = parseInt(targetArgs[2].trim());
						if(sourceZone == 'default'){
							sourceZone = ""+MenuNode.ioService.deviceInfo().getDefaultZoneId();
						}
						if(targetZone == 'default'){
							targetZone = ""+MenuNode.ioService.deviceInfo().getDefaultZoneId();
						}
						let sourceFrames = MenuNode.ioService.deviceInfo().getZoneById(parseInt(sourceZone)).getTimeFrameManager(sourceTable).getTimeFrames(sourceDay);
						
						let targetFrameManager = MenuNode.ioService.deviceInfo().getZoneById(parseInt(targetZone)).getTimeFrameManager(targetTable);
						targetFrameManager.clearDay(targetDay);
						for(let sourceFrame of sourceFrames){
							this.debug("Copying "+sourceFrame.toString());
							let frame = new TimeFrame();
							frame.copy(sourceFrame);
							frame.setDay(targetDay);
							targetFrameManager.addTimeFrame(frame);
						}

						
					}
				}
				case 'value': {
					let oldVal = MenuNode.ioService.getRawValue(parts[1]);

					MenuNode.ioService.setValue(parts[1], parts[2]);
					
					return new ValueChangedConfirmation(parts[1],oldVal,parts[2],context);
					
					return;
				}
				case 'temperature': {
					let defaultZone = MenuNode.ioService.deviceInfo().getDefaultZoneId();
					if (parts.length == 1) {
						MenuNode.ioService.deviceInfo().getZoneById(defaultZone).getSensor('temperature','room_temperature_nominal').setCurrentValue(args);
					} else {
						MenuNode.ioService.deviceInfo().getZoneById(defaultZone).getSensor('temperature',parts[1]).setCurrentValue(args);
					}
					return;
				}
				case 'servicedate':{
					MenuNode.ioService.setServiceDate(args);
					return;
				}
				case 'date':
				case 'time':
				case 'setDate':{
				}
				case 'setTime':{
					MenuNode.ioService.setTime(args);
					return;
				}
				case 'temp':{
					MenuNode.ioService.temporaryValues.set(parts[1],args);
					return;
				}
				default: {
					this.debug("unknown OnConfirm action: " + parts[0]);
					//
				}
			}


		} else {
			this.debug("no onConfirmAction defined for this node.");
		}

	}



	getOnConfirmTarget(context:MenuNode):any {

		this.debug("getOnConfirmTarget");
		if (context.onConfirmAction) {

			let result = context.onConfirmAction.replace('set:', '').replace('{{', '').replace('}}', '');
			this.debug("OnConfirmAction: "+context.onConfirmAction);
			let parts = Helper.split(result,'.');
			switch (parts[0]) {
				case 'menu': {
					return context.findFromRoot(parts[1]);
				}
				case 'sensors':
				case 'sensor':{
						return MenuNode.ioService.sensors.getSensor(parts[1],parts[2]);
				}

				case 'heatingCircuit':{
					this.debug("Getting onConfirmTarget heatingCircuit");
					let idx = parseInt(parts[1]);
					let hc = MenuNode.ioService.deviceInfo().getHeatingCircuitById(idx);

					if(hc === null || hc === undefined){
						this.debug("Cannot get heatingCircuit "+idx);
						return;
					}
					if(hc.hasScale(parts[2])){
						this.debug("returning scale "+parts[2]);
						return hc.getScale(parts[2]);
					}
					this.debug("Cannot make sense of "+parts.join('.'));
					return;
				}
				case 'zone':{
					this.debug("getOnConfirmTarget.zone");
					let idx = parts[1];
					if(idx == 'default'){
						idx = MenuNode.ioService.deviceInfo().getDefaultZoneId().toString();
					}
					
					let zone : ZoneData = MenuNode.ioService.deviceInfo().getZoneById(parseInt(idx));
					if(zone == null || zone == undefined){
						this.debug("No zone found for: "+JSON.stringify(parts));
						return;
					}
					this.debug("getOnConfirmTarget: I was asked for this:"+JSON.stringify(parts));

					switch(parts[2]){
						case 'sensors':
						case 'sensor':{
							return zone.getSensor(parts[3],parts[4]);
						}

						default:{
							if(zone.hasScale(parts[2])){
								return zone.getScale(parts[2]);
							}
							if(zone.hasDate(parts[2])){
								return zone.getDate(parts[2]);
							}
							if(zone.hasValue(parts[2])){
								return zone.getValue(parts[2]);
							}
							this.debug("cannot find action for "+JSON.stringify(parts));
							return;
						}
					}
				
					break;
				}
				case 'zeitprogrammassistent':{

					let data = MenuNode.ioService.getZeitprogrammAssistent();
					if(data.hasScale(parts[1])){
						return data.getScale(parts[1]);
					}
					if(data.hasValue(parts[1])){
						return data.getValue(parts[1]);
					}
					this.debug("Cannot work on "+context.onConfirmAction);
					return;
				}
				case 'temperature': {
					if (parts.length == 1) {
						return MenuNode.ioService.sensors.getTemperatureSensor('desired1');
					} else {
						return MenuNode.ioService.sensors.getTemperatureSensor(parts[1]);
					}
					return null;
				}
				case 'deviceinfo':{
					if(MenuNode.ioService.deviceInfo().hasScale(parts[1])){
						this.debug("Returning scale: "+parts[1]);
						return MenuNode.ioService.deviceInfo().getScale(parts[1]);
					}
					return;
				}
				case 'setDate': {
				}

				case 'setTime': {
					return null; // not handled by an object
				}
				default: {
					this.debug("unknown OnConfirm action: " + parts[0]);
					//
				}
			}
		}
		return null;
	}
	/*
	parseZoneStringOld(parts:Array<string>){
		if(parts[0]!="zone"){
			this.debug("parseZoneString not responsible for that: "+JSON.stringify(parts));
			return;
		}
		let idx = parts[1];
		if(idx == 'default'){
			idx = MenuNode.ioService.deviceInfo().getDefaultZoneId().toString();
		}
		if(idx == 'all'){
			idx = MenuNode.ioService.deviceInfo().getDefaultZoneId().toString();
		}
		
		let zone : ZoneData = MenuNode.ioService.deviceInfo().getZoneById(parseInt(idx));
		if(zone == null || zone == undefined){
			this.debug("No zone found for: "+JSON.stringify(parts));
			return;
		}
		if(parts.length < 3){
			this.debug("No property found in: "+JSON.stringify(parts));
		}
		let property = parts[2];
		switch(property.toLowerCase()){
			case 'name':{
				return zone.getName();
			}
			case 'absenktemperatur':{
				return zone.getAbsenkTemperatur()+"";
			}
			case 'heizmodus':
			case 'heatingmode':{
				return zone.getHeatingMode();						
			}
			case 'kuehlmodus':
			case 'coolingmode':{
				return zone.getCoolingMode();
			}
			case 'desiredtemperature':{"onConfirm": "set:ioService.configuration.currentLanguage.en",
				return zone.getDesiredTemperature()+"";
			}
			case 'absencebegin':{
				this.debug("Timeset " + property + "  " + zone.getAbsenceBegin().getTime());
				return zone.getAbsenceBegin().getTime()+"";
			}
			case 'absenceend':{
				return zone.getAbsenceEnd().getTime()+"";
			}
			case 'sensorvalue':{
				return zone.getSensor(parts[3],parts[4]).getCurrentValue().toString();
			}
			case 'sensors':
			case 'sensor':{
				let sensor = zone.getSensor(parts[3],parts[4]);
				return sensor.toString();
			}
			default:{
				this.debug("cannot find action for "+property);
				return;
			}
		}

	}
	*/



	parseZoneString(parts:Array<string>,options?:string){
		if(parts[0]!="zone"){
			this.debug("parseZoneString not responsible for that: "+JSON.stringify(parts));
			return;
		}
		let idx = parts[1];
		if(idx == 'default'){
			idx = MenuNode.ioService.deviceInfo().getDefaultZoneId().toString();
		}
		if(idx == 'all'){
			idx = MenuNode.ioService.deviceInfo().getDefaultZoneId().toString();
		}
		
		let zone : ZoneData = MenuNode.ioService.deviceInfo().getZoneById(parseInt(idx));
		
		if(zone == null || zone == undefined){
			this.debug("No zone found: idx "+idx+" Parts: "+JSON.stringify(parts));
			return;
		}

		if(parts.length < 3){
			this.debug("No property found in: "+JSON.stringify(parts));
		}

		let property = parts[2];
		if(zone.hasValue(property)){
			if(options == 'raw'){
				return zone.getRawValue(property);	
			}
			return zone.getValue(property);
		}
		
		if(zone.hasDate(property)){
			if(parts.length > 3){
				if(parts[3]=='asDate'){
					return Helper.formatDate(zone.getDate(property));
				}
				if(parts[3]=='asTime'){
					return Helper.formatTime(zone.getDate(property));
				}
			}
			return zone.getDate(property).getTime().toString();
		}


		let sensor = zone.getSensor(parts[3],parts[4]);
		if(sensor != null && sensor != undefined){
			if(parts.length > 5 && parts[5]=='toString'){
				return sensor.toString();
			}else{
				return sensor.getCurrentValue().toString();
			}
		}

		//this.debug("Cannot make sense of zone-data: "+parts.join('.'));
		console.log("Cannot make sense of zone-data: "+parts.join('.'));
	}

	evaluateGetter(text:string,context:MenuNode,options?:string):string{
		let re = new RegExp('{{[a-zA-Z0-9. ]*}}','g');
		let result=text;
		let matches = re.exec(result);
		if(matches == null || matches.length == 0){
			//console.log("Replacing text: "+text);
			return this.evaluateSimpleGetter(text,context,options);
		}
		for(let match of matches){
			//console.log("Replacing :" +match)
			result = result.replace(match,this.evaluateSimpleGetter(match,context,options));
		}
		
		return this.evaluateSimpleGetter(result,context,options);
		
	}


	evaluateSimpleGetter(text: string, context: MenuNode,options?:string): string {

		if(text.startsWith('{{run:')){
			return this.runHook(
				text.replace('run:','').replace('{{run:','').replace('}}',''),
				null,
				context
				);
		}
		

		let result = text.replace('{{get:', '').replace('{{', '').replace('}}', '');

		result = result.trim();
		if(result == text){
			return text;
		}
		let parts = Helper.split(result,'.');
		context.debug("Evaluating getter: "+text);

		switch (parts[0]) {
			case 'configurationParameter':{
				switch(parts[1]){
					case 'currentLanguage':{
						return MenuNode.ioService.getCurrentLanguage();
					}
				}
				return '';
			}
			case 'servicedate':{
				if(parts.length>1 && parts[1]=="toInt"){
					return MenuNode.ioService.getServiceDate().getTime().toString();
				}
				return Helper.formatDate(MenuNode.ioService.getServiceDate());
			}
			case 'time':{
				return Helper.formatTime(MenuNode.ioService.getCurrentTime());
			}
			case 'date':{
				return Helper.formatDate(MenuNode.ioService.getCurrentTime());
			}
			case 'zone':{
				let result = this.parseZoneString(parts,options);
				return result;
			}
			case 'menu':{
				let target = context.findFromRoot(parts[1]);
				switch(parts[2]){
					case 'value':{

						return target.getValue();
					}
					case 'name':{
						return target.getName();
					}
					default:{
						return null;
					}
				}
				return null;
			}
			case 'self': {
				switch (parts[1]) {
					case 'value': {
						//context.debug("returning context.value:" + context.value);
						return context.getValue() + "";
					}
					case 'identifier': {
						return context.getIdentifier() + "";
					}
					case 'name': {
						return context.getName() + "";
					}
					case 'defaultValue': {
						return context.defaultValue + "";
					}
					default: {
						context.debug("Cannot resolve args");
						return;
					}
				}
				return;
			}
			case 'heatingCircuit':{
					let idx = parts['1'];
					if(idx == "all"){
						idx = "1";
					}
					
					let hc = MenuNode.ioService.deviceInfo().getHeatingCircuitById(parseInt(idx));
					if(hc === null || hc === undefined){
						this.debug("HC WAS NULL for idx "+ idx);
						return;
					}
					if(hc.hasScale(parts[2])){
						//console.log("Returning scale "+parts[2]);
						if(parts.length >= 4 && parts[3]=="toString"){
							return hc.getScale(parts[2]).toString();
						}else{
							return ""+hc.getScale(parts[2]).getCurrentValue();
						}						
					}
					if(hc.hasValue(parts[2])){
						if(options == 'raw'){
							return hc.getRawValue(parts[2]);
						}else{
							return hc.getValue(parts[2]);
						}
						
					}else{
						this.debug("No value "+parts[3]+" found on heating-circuit "+idx + " ["+text+"]");
					}

					let obj = MenuNode.ioService;
					let methodName = 'get'+Helper.ucwords(parts[2]);
					if(hc[methodName]){
						return MenuNode.ioService[methodName]();
					}else{
						this.debug(" THERE IS NO METHOD "+methodName + " on heatingCircuit");
						return;
					}
						
					this.debug("Cannot get heatingCiruit " + text);
					return;

			}
			case 'deviceinfo':{

				let devInfo = MenuNode.ioService.deviceInfo()
				if(devInfo.hasScale(parts[1])){
					if(parts.length >= 3 && parts[2]=="toString"){
						return (devInfo.getScale(parts[1])).toString();
					}
					if(parts.length >= 3 && parts[2]=="listEntry"){
						return (devInfo.getScale(parts[1])).getCurrentElement();
					}

					return devInfo.getScaleValue(parts[1]).toString();
				}
				if(devInfo.hasValue(parts[1])){
					if(options == 'raw'){
						return devInfo.getRawValue(parts[1]);
					}else{
						return devInfo.getValue(parts[1]);
					}
				}

				let obj = MenuNode.ioService.deviceInfo();
				//console.log("Object now: "+obj.constructor.name);
				let hasObj = false;

				for(let i=1;i<parts.length;i++){
					let methodName = 'get'+Helper.ucwords(parts[i]);
					if(obj[methodName]){
						hasObj = true;
						obj = obj[methodName]();
						
					}else{
						this.debug("Method not found: "+methodName);
					}
				}
				if(hasObj){
					return obj+"";
				}


				this.debug("I Dont know how to handle "+text+ ". Returning Mode.");
				
				
			}
			case 'ioService':{
				this.debug("Getting from ioService.");
				switch(parts[1]){
					case 'zoneCount':{
						this.debug("Getting from ioService.zoneCount");
						context.debug("Returning zone-count: "+MenuNode.ioService.deviceInfo().getZoneCount().toString());
						this.debug("Returning "+MenuNode.ioService.deviceInfo().getZoneCount().toString());
						return MenuNode.ioService.deviceInfo().getZoneCount().toString();
					}
					default:{
						let obj=MenuNode.ioService;
						let hasObj = false;
						for(let i=1;i<parts.length;i++){
							let methodName = 'get'+Helper.ucwords(parts[i]);
							//this.debug("checking for method "+ methodName + " on "+ obj.constructor.name);
								if(obj[methodName]){
									hasObj = true;
									obj = obj[methodName]();
							}else{
								//this.debug("Method not found: "+methodName);
							}
						}
						if(hasObj){
							return obj+"";
						}
						return '';
						/*
						let obj = MenuNode.ioService;
						this.debug("Getting from MenuNode.ioService");
						let methodName = 'get'+Helper.ucwords(parts[1]);
						if(!obj){
							this.debug("Object was null: MenuNode.ioService" );
						}
						if(obj[methodName]){
							return obj[methodName]();
						}else{
							this.debug(" THERE IS NO METHOD "+methodName + " on "+ obj.constructor.name);
						}
						return;
						*/
					}
				}
			}
			case 'zeitprogrammassistent':{

				let data = MenuNode.ioService.getZeitprogrammAssistent();
				if(data.hasScale(parts[1])){
					if(parts.length >= 3 && parts[2]=="toString"){
						return (data.getScale(parts[1])).toString();
					}
					return data.getScaleValue(parts[1]).toString();
				}
				if(data.hasValue(parts[1])){
					if(options == 'raw'){
						return data.getRawValue(parts[1]);
					}else{
						return data.getValue(parts[1]);
					}
				}

				let obj = MenuNode.ioService.getZeitprogrammAssistent();
				let hasObj = false;

				for(let i=1;i<parts.length;i++){
					let methodName = 'get'+Helper.ucwords(parts[i]);
					if(obj[methodName]){
						hasObj = true;
						
						obj = obj[methodName]();
					}else{
						this.debug("Method not found: "+methodName);
					}
				}
				if(hasObj){
					return obj+"";
				}
run:
				this.debug("Cannot work on "+text);
				return;
			}
			case 'value': {
				//context.debug("Returning value for " + parts[1]);
				if(options == 'raw'){
					return MenuNode.ioService.getRawValue(parts[1]);
				}else{
					return MenuNode.ioService.getValue(parts[1]);
				}
			}
			case 'sensor': {
				let sensor: BaseSensor;
				switch (parts[1]) {
					case 'temperature': {
						sensor = MenuNode.ioService.sensors.getTemperatureSensor(parts[2]);
						break;
					}
					case 'humidity': {
						sensor = MenuNode.ioService.sensors.getHumiditySensor(parts[2]);
						break;
					}
					case 'airquality':{
						sensor = MenuNode.ioService.sensors.getAirQualitySensor(parts[2]);
						break;
					}
					case 'ventilation':{
						sensor = MenuNode.ioService.sensors.getVentilationSensor(parts[2]);
						break;
					}
					case 'pressure': {
						sensor = MenuNode.ioService.sensors.getPressureSensor(parts[2]);
						break;
					}
					default: {

					}
				}

				if (sensor != null && sensor != undefined) {
					return sensor.toString();
				} else {
					context.debug("Error: unparsable: " + text);
				}
				break;
			}
			default: {
				context.debug("cannot parse:" + text);
			}
		}
	}


	static ucwords(str: string){
		return str.replace(/\b[a-z]/g, function(letter) {
    		return letter.toUpperCase();
		});
	}
	static threeDigits(data:string|number):string{
  		let _data:string;
  		if(typeof(data) == "number"){
  			_data = data.toString();
  		}else{
  			_data = ""+data;
  		}
  		if(_data.length==2){
  			return "0"+_data;
  		}
  		if(_data.length == 1){
  			return "00"+_data
  		}
  		return _data;

  	}
  	static twoDigits(data:string|number):string{
  		let _data:string;
  		if(typeof(data) == "number"){
  			_data = data.toString();
  		}else{
  			_data = data;
  		}
  		if(_data.length==2){
  			return _data;
  		}else{
  			return "0"+_data
  		}

  	}
  	static split(str:string,delimiter:string):Array<string>{
  		return str.split(delimiter);
  		//return str.replace('\\'+delimiter,'{{ph}}').split(delimiter).map( (x)=>{return x.replace('{{ph}}',delimiter);});
  	}
	static formatDate(date: Date){
		let str =  Helper.twoDigits(date.getDate())+"."+Helper.twoDigits((date.getMonth()+1))+"."+(date.getFullYear().toString());
		return str;
	}
	static formatTime(date: Date):string{
		return Helper.twoDigits(date.getHours())+":"+Helper.twoDigits(date.getMinutes());
	}
	static minutesAndSeconds(seconds: number){
		return Helper.twoDigits(""+parseInt(""+(seconds/60)))+":"+Helper.twoDigits(""+(""+(seconds%60)));
	}
}